// PortfolioFooterTable.js
import React from "react";
import ColGroupFooter from "@portfolio/PFGridComponents/ColGroupFooter";
import { formatIndianValue } from "@portfolio/utils/formatNumber";
import {useSharingContext} from "@dashboard/contexts/SharingContext"; // same util used everywhere

const PortfolioFooterTable = ({ totals }) => {

    const { showFormattedNumbers } = useSharingContext();

    // Helper that formats if enabled:
    const fmt = (value) =>
        showFormattedNumbers
            ? formatIndianValue(value)
            : Number(value ?? 0).toFixed(2);

    return (
        <div className="pf-footer-table-container">
            <table className="pf-footer-table" cellPadding="5" cellSpacing="0">
                <ColGroupFooter />

                <tfoot>
                <tr>
                    <td>Total:</td>

                    <td>
                        {fmt(totals.totalTodayGain)} <br />
                        <span
                            style={{
                                fontSize: "12px",
                                color: totals.totalTodayGainPercentage >= 0 ? "green" : "red",
                            }}
                        >
                                {totals.totalTodayGainPercentage}%
                            </span>
                    </td>

                    <td>
                        {fmt(totals.totalOverallGain)} <br />
                        <span
                            style={{
                                fontSize: "12px",
                                color: totals.totalOverallGainPercentage >= 0 ? "green" : "red",
                            }}
                        >
                                {totals.totalOverallGainPercentage}%
                            </span>
                    </td>

                    <td></td>

                    <td>{fmt(totals.totalCurrentValue)}</td>

                    <td></td>

                    <td>{fmt(totals.totalAmountInvested)}</td>

                    <td></td>
                </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default PortfolioFooterTable;
